
import useDetectMobile from "./useDetectMobile";
import useIsOnboardingCertificatesAvailable from "./useIsOnboardingCertificatesAvailable";
import useTypedFlags from "./useTypedFlags";

const useIsLearnViewAvailable = () => {
  const { assistantPanelLearnView } = useTypedFlags();
  const isOnboardingCertificatesAvailable = useIsOnboardingCertificatesAvailable();
  const isMobile = useDetectMobile();

  return assistantPanelLearnView && isOnboardingCertificatesAvailable && !isMobile;
};

export default useIsLearnViewAvailable;
